export default __webpack_public_path__ + "static/img/33.c28e547.png";